
export class PlanType {
  id!: string;
  name!: string;
}
